module.exports = __webpack_public_path__ + "static/media/prada.d9f663d6.jpg";